export default "__VITE_ASSET__Bq5At5dl__"